// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"296":"privacy","443":"about","631":"contact","637":"order","729":"term"}[chunkId] + "." + {"296":"4bf2561a","443":"777cd579","631":"5525e7e5","637":"aa809b9f","729":"44419db4"}[chunkId] + ".css";
};